import {PartnerSummaryModel} from '../../../../../partner/common/api/model/partnerSummary.model';
import {SummaryModel} from '../../../../../common/entity/summary.model';
import * as moment from 'moment-timezone';
import {PermissionsModel} from '../../../../../common/entity/permissions.model';

export class MedicalRecordPainIntensityModel implements SummaryModel {
    id: number;
    partner: PartnerSummaryModel;
    date: moment.Moment;
    intensity: number;
    comment: string;
    permissions: PermissionsModel;

}
